import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { UsuariosService } from '../../../services/usuarios.service';
import * as _timezones from 'projects/shared-components/src/lib/assets/timezone.json'
import { Subject } from 'rxjs';

@Component({
    selector: 'app-send-invitation',
    templateUrl: './send-invitation.component.html'
})
export class SendInvitationComponent implements OnInit {

    private _etiquetador;
    public sendInvitationForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();
    public toCloseSpinner = 0;

    public disabledEtiquetadores: Subject<boolean> = new Subject();

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _usuariosService: UsuariosService
    ) {}

    ngOnInit() {
        this.sendInvitationForm = this._fb.group({
            etiquetador: ['', Validators.required],
            email: ['', [Validators.required, Validators.pattern('^[A-z0-9._%+-]+@[A-z0-9.-]+\\.[a-z]{2,4}$')]],
            idiomaId: ['', Validators.required],
            msTimeZoneId: ['', Validators.required],
        });
    }

    public get etiquetadores() {
        if (this._dataProvider.etiquetadores && this._dataProvider.etiquetadores.length === 1) {
            this.sendInvitationForm.get('etiquetador').patchValue(this._dataProvider.etiquetadores[0]);
            this.sendInvitationForm.get('etiquetador').disable({onlySelf: true, emitEvent: false});
            this.disabledEtiquetadores.next(true);
        } else {
            this.sendInvitationForm.get('etiquetador').enable({onlySelf: true, emitEvent: false});
        }
        return this._dataProvider.etiquetadores;
    }

    public get idiomas() {
        return this._dataProvider.idiomas;
    }

    public get timezones() {
        return this._dataProvider.timeZones;
    }

    public close() {
        this.refresh.emit(false);
    }

    public send() {
        this.checkForm();
        if (this.sendInvitationForm.valid) {
            this._etiquetador = {
                email: this.sendInvitationForm.get('email').value ? this.sendInvitationForm.get('email').value : null,
                idiomaId: this.sendInvitationForm.get('idiomaId').value ? this.sendInvitationForm.get('idiomaId').value.id : '',
                msTimeZoneId: this.sendInvitationForm.get('msTimeZoneId').value ? this.sendInvitationForm.get('msTimeZoneId').value.id : null
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._usuariosService.enviarInvitacion(this._etiquetador).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemCreated');
            },
            (error) => {
                this.showError = true;
                switch (error.error.ApiErrorCode) {
                    case 1010:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.emailYaExiste' });
                        break;
                    case 1011:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.yaEtiquetador' });
                        break;
                    case 1016:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.usuarioYaAsociadoARol' });
                        break;
                    case 1017:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.invitacionPendiente' });
                        break;
                    default:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.serverError' });
                        break;
                }
            });
        }
    }

    private checkForm() {
        this.showError = this.sendInvitationForm.invalid;
        if (this.showError) {
          this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
        }
    }
}